// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"505":"fdaa5344","519":"b202288b","774":"88c4c9c8","787":"1e48cc4a","854":"48dcd33f","858":"2fede2ab"}[chunkId] + ".chunk.js";
};